import { stringToNode } from '~/dashboard/print/utilities.js';

function createNaavixGraph(chart, index) {
  const page_break_class = index === 0 ? 'dashboard-row--page-break' : '';
  let chartContent = '';
  if (chart.dataSource && chart.dataSource.graph_image) {
    chartContent = `<img src="${chart.dataSource.graph_image}" style="max-width:100%;height:auto;" alt="Naavix Graph" />`;
  }
  const chart_container = stringToNode(`
    <div class="dashboard-row ${page_break_class}">
      <div class="dashboard-row__chart">
        <h3 class="dashboard-row__name">
          ${chart.chart_name}
        </h3>
        ${chartContent}
      </div>
    </div>
  `);

  return chart_container;
}

export { createNaavixGraph };
